import { render, staticRenderFns } from "./examine-detail2.vue?vue&type=template&id=ba527ac4&scoped=true&"
import script from "./examine-detail2.vue?vue&type=script&lang=js&"
export * from "./examine-detail2.vue?vue&type=script&lang=js&"
import style0 from "./examine-detail2.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./examine-detail2.vue?vue&type=style&index=1&id=ba527ac4&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba527ac4",
  null
  
)

export default component.exports